import { Component, OnInit } from '@angular/core';
import { JqueryHelperService } from '../jquery-helper.service';
import { AdItem } from '../container/adds/ad-item';
import { FilterService } from "../shared/filter.service";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "../models/app.state";
import { FilterType } from "../models/Filter";

@Component({
  selector: 'ciu-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private jqueryHelper: JqueryHelperService,
    private filterService: FilterService,
    public router: Router,
    private store: Store<AppState>) {
    this.store.select((data) => {
      return data.filters.filter(f => f.type == FilterType.SEARCH)[0] ? data.filters.filter(f => f.type == FilterType.SEARCH)[0].value.toString() : '';
    }).subscribe(s => this.searchWord = s);
  }

  ads: AdItem[];
  searchWord: string;

  showSearch(): Boolean {
    if (this.router.url.includes('/home') || (this.router.url.includes('/windows') && !this.router.url.includes('/windowDetails'))) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {

    this.jqueryHelper.initMeanMenu();
    this.jqueryHelper.onwindowResize();
  }

  search() {
    this.filterService.search(this.searchWord);
  }

  navigateHome() {
    //this.service
    if (this.router.url.includes('home') || this.router.url.includes('product')) {
      return null;
    } else {
      return 'preserve';
    }
  }

  navigateToWindow() {
    //this.service
    if (this.router.url.includes('window')) {
      return null;
    } else {
      return 'preserve';
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/header/header.component.ts